import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { Edit2, Trash2, X, Check, CheckSquare } from 'react-feather'

// Imports custom
import {
    TooltipInformation,
    CustomTableData,
    LinearLoading,
    CustomDropDown
} from '../../../../common'

export const TableDetail = ({ useFetchInit }) => {
    
    const {
        FetchData,
        Actions
    } = useFetchInit

    const { fetchOperationDetail } = FetchData
    const { dataOperationDetail, loadingFetchOperationDetail } = fetchOperationDetail

    const { 
        handleClickFetchSpecificOperation,
        handleClickEnableUser,
        handleClickEnableDisableOperation,
        handleClickDeleteOperation,
        handleClickMakeOperation
    } = Actions

    const columnConfig = [
        {
            //FIELD PARA TOOLTIP
            headerName: 'Info',
            maxWidth: 80,
            cellStyle: () => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const { usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data
                return (
                    <TooltipInformation
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        // { field: 'fecha_operacion', headerName: 'Fecha', minWidth: 150, filter: true },
        { field: 'modulo', headerName: 'Módulo', minWidth: 200, filter: true },
        { field: 'seccion', headerName: 'Sección', minWidth: 150, filter: true },
        { field: 'idcontrato', headerName: 'Contrato', minWidth: 150, filter: true },
        { field: 'idpago', headerName: 'Pago', minWidth: 150, filter: true },
        { field: 'idtransaccion', headerName: 'Transaccion', minWidth: 150, filter: true },
        {
            headerName: 'Opciones',
            minWidth: 350,
            cellRenderer: (params) => {
                const { idoperacion, estado } = params.data

                // const readOnlyMode = estado === 1 ? 'EDITABLE' : 'READONLY'

                return (
                    <CustomDropDown color={(estado===1)?'inherit':'error'}>
                        {(estado === 1) && (
                            <div>
                                <MenuItem
                                    onClick={() => handleClickFetchSpecificOperation(idoperacion)}
                                >
                                    <ListItemIcon> <Edit2 color="black"/> </ListItemIcon>
                                    <ListItemText primary="Informacion" />
                                </MenuItem>
                                <MenuItem
                                    onClick={() => handleClickDeleteOperation(idoperacion)}
                                >
                                    <ListItemIcon> <Trash2 color="black"/> </ListItemIcon>
                                    <ListItemText primary="Eliminar" />
                                </MenuItem>
                                <MenuItem
                                    onClick={() => handleClickEnableDisableOperation(idoperacion, 0)}
                                >
                                    <ListItemIcon> <X color="black"/> </ListItemIcon>
                                    <ListItemText primary="Cerrar" />
                                </MenuItem>
                            </div>
                        )}
                        {(estado === 0) && (
                            <MenuItem
                                onClick={() => handleClickEnableDisableOperation(idoperacion, 1)}
                            >
                                <ListItemIcon> <Check color="black"/> </ListItemIcon>
                                <ListItemText primary="Abrir" />
                            </MenuItem>
                        )}
                    </CustomDropDown>
                )
            }
        }
    ]

    return (
        <div className='content'>
            {(loadingFetchOperationDetail)&&(<LinearLoading/>)}
            <CustomTableData 
                rowConfig={dataOperationDetail}
                columnConfig={columnConfig}
                customHeight={{
                    height: '40vh',
                    margin: 0
                }}
            />
        </div>
    )
}
